import './Card.css';

/**
 * Tarjeta contenedora. `as` permite cambiar el tag (article, section, etc.).
 * `hover` agrega efecto al pasar el mouse (para tarjetas clickeables).
 */
export default function Card({ as: Tag = 'div', hover = false, className = '', children, style, ...rest }) {
  const cls = ['card', hover ? 'card-hover' : '', className].filter(Boolean).join(' ');
  return <Tag className={cls} style={style} {...rest}>{children}</Tag>;
}